import { Injectable } from '@angular/core';
import { map, Observable } from "rxjs";
import {NotificationHttpService} from "./https/notification-http.service";
import {
  INotificationModel,
  IResultNotificationModel,
  NotificationModel,
  ResultNotificationModel
} from "../../models/accounts/notification.model";


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private notificationHttpService: NotificationHttpService) { }

  findAll(limit: number = 100, offset: number = 0): Observable<ResultNotificationModel> {
    return this.notificationHttpService
      .filter({}, limit, offset)
      .pipe(
        map((notification: IResultNotificationModel) => ResultNotificationModel.fromObject(notification))
      );
  }

  find(id: number): Observable<NotificationModel> {
    return this.notificationHttpService
      .find(id)
      .pipe(
        map((notification: INotificationModel) => NotificationModel.fromObject(notification))
      );
  }

  filter(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<ResultNotificationModel> {
    return this.notificationHttpService
      .filter(wheres, limit, offset)
      .pipe(
        map((notification: IResultNotificationModel) => ResultNotificationModel.fromObject(notification))
      );
  }

  save(notification: NotificationModel): Observable<NotificationModel> {
    return this.notificationHttpService
      .save({
        id: notification.id as number,
        title: notification.title,
        message: notification.message,
        url_access: notification.url_access,
        unread: notification.unread,
        level: notification.level,
        user_id: notification.userId
      })
      .pipe(
        map((notification: INotificationModel) => NotificationModel.fromObject(notification))
      );
  }

  delete(notification: NotificationModel): Observable<any> {
    return this.notificationHttpService
      .delete(notification.id as number);
  }
}
